import { FC, useContext, useEffect, useState } from 'react';
import { AppShell } from '@mantine/core';
import { Outlet, useLocation } from 'react-router-dom';
import { IconFileDescription, IconFilter } from '@tabler/icons';
import { DocumentsContextProvider } from '../../Service/Context/DocumentsContext';
import { WindowContext } from '../../Service/Context/WindowContext';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../../Templates/Navigation/PageHeader';
import { RoutingS } from '../../Service/RoutingS';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../../Templates/Navigation/phone/BookitupFooter';
import DocumentsPageFooter from '../../Templates/Navigation/phone/DocumentsPageFooter';
import DocumentListNavLinks from './DocumentListNavLinks';
import DocumentHeadActions from '../../Templates/Documents/DocumentHeadActions';

const DocumentsPage: FC = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { pathname } = useLocation();
  const hideFooter = pathname !== '/documents';

  useEffect(() => {
    RoutingS.changeTitle('Dokumente');
  }, []);

  return (
    <DocumentsContextProvider>
      <AppShell
        header={<PageHeader />}
        navbar={
          sm ? undefined : (
            <DoubleNavbar>
              <DocumentListNavLinks />
            </DoubleNavbar>
          )
        }
        styles={(theme) => ({
          main: {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit',
          },
        })}
        footer={
          sm && !hideFooter ? (
            <BookitupFooter>
              <DocumentsPageFooter filter={() => setDrawerOpened(true)} />
            </BookitupFooter>
          ) : undefined
        }
      >
        {sm && (
          <NavDrawer
            label="Dokumente"
            icon={<IconFileDescription size={32} />}
            opened={drawerOpened}
            onClose={() => setDrawerOpened(false)}
          >
            <DocumentListNavLinks />
          </NavDrawer>
        )}
        <Outlet />
      </AppShell>
    </DocumentsContextProvider>
  );
};

export default DocumentsPage;
